import { Request } from './Request';

export class HasSiteLicensingConsumptionInfoRequest extends Request<{}, boolean> {
  constructor() {
    super('hasSiteLicensingConsumptionInfo', {});
  }
}
